import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { forwardRef } from "react";
import { SIcon } from "./components";
const SInputV2 = /*#__PURE__*/ forwardRef(({ className, borderless = false, iconType, styleless, ...props }, ref)=>{
    const baseStyles = "appearance-none w-full px-3 !text-[13px]";
    const borderClassStyles = borderless ? "border-none focus:border-none focus:ring-0 focus:outline-none transition" : "bg-grayscale-dark !h-[32px] rounded-md border-white/10 focus:border-white/30 focus:ring-0 focus:outline-none transition";
    const disabledClassStyles = props.disabled ? "text-white/50 cursor-not-allowed" : "";
    const input = /*#__PURE__*/ _jsx("input", {
        ref: ref,
        ...props,
        className: styleless ? className : `${baseStyles} ${borderClassStyles} ${disabledClassStyles} ${className}`
    });
    return iconType ? /*#__PURE__*/ _jsxs("div", {
        className: "relative w-full",
        children: [
            /*#__PURE__*/ _jsx("input", {
                ref: ref,
                ...props,
                className: `${baseStyles} ${borderClassStyles} ${className} !pr-10`
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "absolute right-[9px] z-10 top-[9px] bottom-[9px] transform flex flex-row items-center justify-center pl-[9px] border-l border-white/10",
                children: /*#__PURE__*/ _jsx(SIcon, {
                    size: 12,
                    className: "opacity-50",
                    type: iconType
                })
            })
        ]
    }) : input;
});
export { SInputV2 };
